import React from 'react';
import { Box, Typography } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface RecommendationsProps {
  data: Record<
    string,
    {
      device: string;
      recommendations: string[];
    }
  >;
  showIndexes?: number[];
  enableDarkTheme: boolean;
}

const RecommendationsList: React.FC<RecommendationsProps> = ({
  data,
  showIndexes = [0, 1, 3, 4],
  enableDarkTheme,
}) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const { t } = useTranslation();
  const fontColor = palette.textPrimary;
  const isEmpty = !data || Object.keys(data).length === 0;

  if (isEmpty) {
    return (
      <Typography
        sx={{
          fontSize: '14px',
          marginTop: '10px',
          color: fontColor,
        }}
      >
        {t('no_suggestions_available')}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        marginTop: '20px',
      }}
    >
      {Object.values(data).map((item) => (
        <Box key={item.device} mb={2}>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: '600',
              color: ThemePalette.typography.grey,
            }}
          >
            {t('device')} {item.device}
          </Typography>
          {item.recommendations
            .filter((_, idx) => showIndexes.includes(idx))
            .map((rec, idx) => (
              <Typography
                key={idx}
                sx={{
                  mb: 0.5,
                  fontSize: '12px',
                  color: fontColor,
                }}
              >
                {rec}
              </Typography>
            ))}
        </Box>
      ))}
    </Box>
  );
};

export default RecommendationsList;
